import { CheckupTag, CheckupTags, GaitMlResults } from './apiTypes';

// onlyCheckupTags throws an error if any of the passed in array of strings are not valid checkup tags.  If all the tags
// are valid, it returns an array of CheckupTags (so that the type is narrowed to CheckupTag[]).
export const onlyCheckupTags = (tags: string[] = []): CheckupTag[] => {
  if (!tags.every((tag: string) => CheckupTags?.[tag])) {
    throw new Error(`Invalid checkup tag: ${tags.find((tag: string) => !CheckupTags?.[tag])}`);
  }

  return tags as CheckupTag[];
};

// isGaitMlResults checks if the provided results object is a valid GaitMlResults type.  If true, it also narrows the
// type to GaitMlResults.
export const isGaitMlResults = (results: unknown): results is GaitMlResults => {
  return typeof results === 'object' && results !== null && 'analysis' in results && results.analysis === 'gait';
};
